export enum LOCALE {
  DE = "de-DE",
  EN = "en-GB",
  NL = "nl-NL",
  US = "en-US",
}
